import { createStore } from 'vuex'

export default createStore({
  state: {
    user: null,
  },
  mutations: {
    setUser(state, user) { console.log("Change user"); state.user = user }
  },
  actions: {
  },
  modules: {
  }
})
